import React from 'react';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Text,
} from '@knockrentals/knock-shared-web';

import { CloudLoadingImage } from './images';
import './_SSDAPage.scss';


const useStyles = makeStyles({
  kdcInfoDescription: {
    color: '#999999',
  },
});


const SSDALoading = ({ companyName }) => {
  const classes = useStyles();

  return (
    <div className="knock-data-cloud-setup">
      <div className="setup-image-container">
        <span>
          <CloudLoadingImage />
        </span>
                
        <Text align="center" color="textSecondary" variant="h3">
          Credentials Processing
        </Text>

        <Text align="center" variant="h5" className={classes.kdcInfoDescription}>
          {companyName}
        </Text>
      </div>
    </div>
  );
};

SSDALoading.propTypes = {
    companyName: PropTypes.string,
};

export default SSDALoading;
